import React, {useState} from 'react';

import Button, {FlatButton} from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogHole} from '@pb/kit-component-dialog-v2';
import Group, {Item} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Loading, Types} from '@pb/kit-component-loading';

type Props = {
    attributeName: string,
    description: string,
    isDisabled: boolean,
    setDescription: (description: string) => void,
    onGenerating: boolean,
    onGenerateClick: () => void,
    onDescriptionGenerate: (description: string) => void,
};

const DESCRIPTION_PLACEHOLDER = 'Click the button below to generate a description for the attribute';

export const AttributeDescriptionGenerationView = (props: Props) => {
    const {
        attributeName,
        description,
        isDisabled,
        setDescription,
        onGenerating,
        onGenerateClick,
        onDescriptionGenerate,
    } = props;

    const [shown, setShown] = useState(false);

    const onClose = () => {
        setDescription('');
        setShown(false);
    };

    const onApply = () => {
        onDescriptionGenerate(description);
        setShown(false);
    };

    return (
        <Dialog
            setShown={setShown}
            shown={Boolean(shown && !isDisabled)}
            anchor={({anchorRef, getAnchorProps}) => (
                <BasicIconButton
                    ref={anchorRef}
                    {...getAnchorProps()}
                    iconProps={{type: Icons.SPARKLES, size: Sizes.Size_16}}
                    disabled={isDisabled}
                />
            )}>
            <Group direction="v" justify="space-between" className="pb-m" style={{minWidth: 500}}>
                <DialogHeader onClose={onClose}>
                    <Group direction="v">
                        <Item>AI Assistant</Item>
                        <Item>{attributeName}</Item>
                    </Group>
                </DialogHeader>
                <DialogHole>
                    <Group direction="v" gap="m">
                        <Group>
                            <Item><strong>Generated Description:</strong></Item>
                            {onGenerating ? (
                                <Loading fast={true} type={Types.ICON}/>
                            ) : null}
                        </Group>
                        <Item style={{minHeight: '3rem'}}>
                            <Item>
                                {description || DESCRIPTION_PLACEHOLDER}
                            </Item>
                        </Item>
                    </Group>
                    <Group justify="end">
                        <FlatButton disabled={!description || onGenerating} onClick={onApply}>Apply</FlatButton>
                    </Group>
                </DialogHole>
                <DialogFooter>
                    <Button style={{width: '100%'}} variant="Type.SECONDARY" onClick={onGenerateClick}>
                        Generate Description
                    </Button>
                </DialogFooter>
            </Group>
        </Dialog>
    );
};
